import { render } from "./XIconSolidTrendingUp.vue?vue&type=template&id=738ae1ce"
import script from "./XIconSolidTrendingUp.vue?vue&type=script&lang=js"
export * from "./XIconSolidTrendingUp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidTrendingUp.vue"]])

export default __exports__